<template>
    <el-dialog
            width="650px"
            :title="'批量设置字段'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="批量更新字段列表：">
                {{ruleItemName}}
            </el-form-item>
            <el-form-item label="字段：" prop="ruleItemId">
                <el-select v-model="dataForm.columnName" filterable placeholder="字段"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in columnNameList"
                            :key="item.columnName"
                            :label="item.title"
                            :value="item.columnName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="columnType===2" label="字段值" prop="columnBoolValue">
                <el-select v-model="dataForm.columnBoolValue" placeholder="请选择"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="columnType===1" label="字段值" prop="columnValue">
                <el-input v-model="dataForm.columnValue" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item v-if="columnType===3" label="验证规则类型" prop="validType">
                <el-select v-model="dataForm.validType" placeholder="验证规则类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in validTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="columnType===4" label="数据类型" prop="dataType">
                <el-select v-model="dataForm.dataType" placeholder="数据类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in dataTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    ruleId: '',
                    columnName: '',
                    columnBoolValue: false,
                    columnValue: '',
                    dataType: '0',
                    validType: '1'
                },
                validTypeList: [],
                ruleItemIds: [],
                ruleItemName: '',
                dataTypeList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataListSelections: [],
                columnNameList: [
                    {columnName: 'isUnionIndex', title: '是否为查重字段'},
                    {columnName: 'required', title: '是否必填'},
                    {columnName: 'validType', title: '验证规则类型'},
                    {columnName: 'dataType', title: '数据类型'},
                    {columnName: 'jsonContent', title: '匹配字符串长度'},
                    {columnName: 'patternRegex', title: '匹配表达式'},
                ],
                dataRule: {
                    columnName: [
                        {required: true, message: '请选择字段', trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            columnType: {
                get() {
                    if (this.dataForm.columnName === 'dataType') {
                        return 4
                    } else if (this.dataForm.columnName === 'validType') {
                        return 3
                    } else if (this.dataForm.columnName === 'isUnionIndex' ||
                        this.dataForm.columnName === 'required' ||
                        this.dataForm.columnName === 'hidden' ||
                        this.dataForm.columnName === 'single' ||
                        this.dataForm.columnName === 'canEdit' ||
                        this.dataForm.columnName === 'showInList') {
                        return 2
                    } else {
                        return 1
                    }
                }
            }
        },
        methods: {
            getHttpReq(url, method = 'post', extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL: '',
                }
                ops = Object.assign(ops, extOps)
                return this.$http(ops)
            },
            init(ruleId, dataListSelections) {
                let _self = this
                this.dataForm.ruleId = ruleId || ''
                this.dataListSelections = dataListSelections || []
                this.ruleItemIds = []
                let desc
                for (var i = 0; i < this.dataListSelections.length; i++) {
                    if (desc) {
                        desc = desc + ',' + this.dataListSelections[i].itemName
                    } else {
                        desc = this.dataListSelections[i].itemName
                    }
                    this.ruleItemName = desc
                    this.ruleItemIds.push(this.dataListSelections[i].id)
                }
                _self.visible = true
                _self.$nextTick(() => {
                    _self.$refs['dataForm'].resetFields()
                })
                axios.all([
                    this.getHttpReq('/statis/getEnumList/1', 'get'),
                    this.getHttpReq('/statis/getEnumList/2', 'get'),
                ])
                    .then(axios.spread(function (dataTypeResult, validResult) {
                        _self.dataTypeList = dataTypeResult.data
                        _self.validTypeList = validResult.data
                    }))
            },
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let value
                        if (this.columnType === 4) {
                            value = this.dataForm.dataType;
                        } else if (this.columnType === 3) {
                            value = this.dataForm.validType;
                        } else if (this.columnType === 2) {
                            value = this.dataForm.columnBoolValue;
                        } else {
                            value = this.dataForm.columnValue;
                        }
                        this.$http({
                            url: this.$http.adornUrl('/api/dataset/ruleitem/batchUpdate'),
                            method: 'post',
                            baseURL: '',
                            data: {
                                ruleItemIds: this.ruleItemIds,
                                propertyName: this.dataForm.columnName,
                                value: value
                            }
                        }).then(({data}) => {
                            if (data && data.code === '1') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 150,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            }
        }
    }
</script>
